module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo-4-7577cef3646d0d4aa3a92caff7e527f0.png";